// extracted by mini-css-extract-plugin
export var box = "_7j-1";
export var checkboxRow = "_7j-8";
export var checked = "_7j-2";
export var descriptionSpacer = "_7j-a";
export var disabled = "_7j-3";
export var icon = "_7j-6";
export var input = "_7j-0";
export var labelSpacer = "_7j-9";
export var medium = "_7j-5";
export var small = "_7j-4";
export var text = "_7j-7";